<template>
  <q-toolbar>
    <q-toolbar-title class="text-subtitle1 text-grey-7">
      <post-link :url="post.link" :social-site="post.socialSite" />
    </q-toolbar-title>
    <post-group-btn
      v-if="group && post.parent"
      :post-group="post.parent"
      class="q-ml-sm"
      round
      flat
    />
    <post-faces-btn
      :post="post"
      class="q-ml-sm"
      round
      flat
    />
    <post-notes-btn
      v-if="notes"
      :post="post"
      class="q-ml-sm"
      :title="notesBtnTitle"
      round
      flat
    />
    <trash-btn
      v-if="!post.isTrashed && trash"
      :post="post"
      round flat
      class="q-ml-sm"
      @trashed="$emit('trashed', $event[0])"
    />
    <slot />
  </q-toolbar>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Post } from '@/type';
import PostGroupBtn from '../group/PostGroupBtn.vue';
import PostNotesBtn from '../note/PostNotesBtn.vue';
import TrashBtn from '../trash/TrashBtn.vue';
import PostFacesBtn from './PostFacesBtn.vue';
import PostLink from './PostLink.vue';

export default defineComponent({
  emits: ['trashed'],
  components: {
    PostGroupBtn,
    PostFacesBtn,
    PostNotesBtn,
    TrashBtn,
    PostLink,
  },
  props: {
    post: {
      type: Object as () => Post,
      required: true,
    },
    group: {
      type: Boolean,
      default: false,
    },
    notes: {
      type: Boolean,
      default: false,
    },
    notesBtnTitle: {
      type: String,
      default: undefined,
    },
    trash: {
      type: Boolean,
      default: false,
    },
  },
});
</script>
